import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../helpers/language';

const PartnerStatementSection = () => {
    const { language } = useLanguage();
    const t = translations[language].partnerStatement;

    return (
        <section className="secction-image" data-aos="fade-up">
            <h1 className="title-img">{t.text}</h1>
        </section>
    );
};

export default PartnerStatementSection;
